module.exports = __webpack_public_path__ + "img/Motif-Carreaux.35cf315d.jpg";